import { Typography } from '@weareopenr/component-library';
import styles from '../SyncReportModal.module.scss';

export const SyncModalItemSubHeaders = ({ showCheckbox }: { showCheckbox: boolean }) => {
  return (
    <div className={styles['subHeader-container']}>
      <div>
        <Typography weight="semi-bold">Product name</Typography>
      </div>
      {showCheckbox && (
        <div>
          <Typography weight="semi-bold">Modifier</Typography>
        </div>
      )}
    </div>
  );
};
